module.exports = __webpack_public_path__ + "img/badge-batik-air.7e6cc446.svg";